/**
 * R-78 — Tier-1 provider precedence rule injected before the SED evidence dump.
 */
export const PROVIDER_PRECEDENCE_RULE_BLOCK =
  'PRECEDENCE RULE — non-negotiable: When a canonical fact ' +
  '(capacity, interconnection distance, flood zone, voltage, substation name, ' +
  'water source, nuclear proximity, census tract, grid operator) appears in BOTH ' +
  'a Tier-1 structured provider (labeled [PROVIDER:NREL|USGS|EIA|FEMA|USFWS|NRC|PEERINGDB|HIFLD|WRI|AIRNOW]) ' +
  'AND a Tier-3 source (AI-Research, web scrape, LLM inference), you MUST use the Tier-1 value verbatim. ' +
  'Cite the Tier-1 source. If the Tier-1 value seems wrong, flag it in the Caveats section ' +
  'rather than substituting the Tier-3 value.';

/** Prepend precedence rule immediately before SED / evidence text in prompts. */
export function wrapSedTextForPrompt(sedText: string): string {
  const trimmed = sedText?.trim() ?? '';
  if (!trimmed) return trimmed;
  return `${PROVIDER_PRECEDENCE_RULE_BLOCK}\n\n${trimmed}`;
}

/** Build the framed SED block used by generateReportContent (precedence before dump). */
export function buildSedSectionForPrompt(rawSedText: string | undefined): string {
  if (!rawSedText?.trim()) return '';
  const body = wrapSedTextForPrompt(rawSedText);
  return (
    `\n\n═══ SITE EVIDENCE DOCUMENT (AUTHORITATIVE — USE THIS AS PRIMARY SOURCE) ═══\n` +
    `${body}\n` +
    `═══ END SITE EVIDENCE DOCUMENT ═══\n\n` +
    `IMPORTANT: The Site Evidence Document above is the verified factual record. ` +
    `Every data point traces to a specific API call. Sections marked [UNAVAILABLE] have no data — ` +
    `do NOT estimate or invent values for these. Sections marked [ANOMALOUS] have data quality flags — ` +
    `note the anomaly in your analysis.\n`
  );
}
